import { Capacitor } from "@capacitor/core";
import swMySworkitState from "../stencil-store/sw-my-sworkit.store";
import { statusBarManager } from "./status-bar";
import { isPageWithDarkBackgroundLightIcons } from "../actions/router";

class DarkModeManager {
  private static instance: DarkModeManager;
  private mediaQuery: MediaQueryList;

  private constructor() {
    this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    // Initialize with current system preference
    this.handleDarkModeChange(this.mediaQuery.matches);
  }

  public static getInstance(): DarkModeManager {
    if (!DarkModeManager.instance) {
      DarkModeManager.instance = new DarkModeManager();
    }
    return DarkModeManager.instance;
  }

  public initialize() {
    // Add listener for system dark mode changes
    this.mediaQuery.addEventListener("change", (e) => {
      this.handleDarkModeChange(e.matches);
    });
  }

  public cleanup() {
    // Remove listener when component unmounts
    this.mediaQuery.removeEventListener("change", (e) => {
      this.handleDarkModeChange(e.matches);
    });
  }

  private handleDarkModeChange(isDark: boolean) {
    // Update the global state
    swMySworkitState.prefersDark = isDark;
    
    // Update status bar if on native platform
    if (Capacitor.isNativePlatform()) {
      statusBarManager.setPrefersDark(isDark);
      // Only update status bar if we're on a dark background page
      const darkBackground = isPageWithDarkBackgroundLightIcons(window.location.pathname);
      if (!darkBackground) {
        statusBarManager.updateStatusBar(window.location.pathname);
      }
    }
  }

  public get isDarkMode(): boolean {
    return swMySworkitState.prefersDark;
  }
}

export const darkModeManager = DarkModeManager.getInstance(); 